import { AppProviders } from './app/AppProviders';

export default function App(): JSX.Element {
  return <AppProviders />;
}
